import React from 'react';
import { Tabs } from 'antd';
import Layout from '../../../components/Layout';
import ProductReports from './ProductReports';
import PricingUsageStatistics from './PricingUsageStatistics';

const { TabPane } = Tabs;

const B2BReports = () => {

  return (
    <Layout>
      <h1>B2B Reports and Statistics</h1>
      <Tabs defaultActiveKey="productReports">
        <TabPane tab="Product Reports" key="productReports">
          <ProductReports />
        </TabPane>
        <TabPane tab="Pricing Usage Statistics" key="pricingUsageStatistics">
          <PricingUsageStatistics />
        </TabPane>
      </Tabs>
    </Layout>
  );
};

export default B2BReports;
